/**
 * 화면을 새로 불러온다. 한 곳에 둔 이유는 테스트가 이것만 바꿔 끼울 수 있게 하려는 것이다
 * (jsdom 의 `window.location.reload` 는 바꿀 수 없다).
 */
export function reloadPage() {
    window.location.reload();
}

export default reloadPage;
